import React, { useState } from 'react';
import PropTypes from "prop-types";
import axios from 'axios';

// Components
import FileInput from './FileInput';

/** App functional component */
function ImageCrop(props) {
  const [image, setImage] = useState(props.image)
  const [removeUrl, setRemoveUrl] = useState(props.remove_url)

  const upload = (file) => {
    // New-member mode: stash the cropped file into the form's hidden file input
    // so it rides along with the normal create submit (no record to POST to yet).
    if (props.input_id) {
      const input = document.getElementById(props.input_id);
      const dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
      return;
    }

    const data = new FormData();
    data.append('file', file);

    axios.post(props.upload_url, data).then(function (res) {
      setRemoveUrl(`/attachments/${res.data.image.id}.json?purge=true`)
      toastr.success('The image has been updated successfully')
    })
    .catch(function (error) {
      toastr.error('Failed to upload the image')
      console.log(error)
    })
  }

  const remove = () => {
    axios.delete(removeUrl).then(() => {
      setImage('/images/missing.png');
      setRemoveUrl(null);
      toastr.error('The image has been deleted successfully')
    })
  }

  return (
    <div className="mt-4">
      <FileInput onUpload={upload} onRemove={remove} image={image} removeUrl={removeUrl} />
    </div>
  )
}

ImageCrop.propsTypes = {
  upload_url: PropTypes.string,
  input_id: PropTypes.string,
  image: PropTypes.string,
  remove_url: PropTypes.string
};

export default ImageCrop;
